import { KYMW0C00Model } from '../kymw0c00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　取引先名称を取得するサービス
 *
 * @export GetSupplierNameService
 * @class GetSupplierNameService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSupplierNameService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetSupplierNameService
   */
  private model: KYMW0C00Model;

  /**
   * 受取り条件値 サンプル発注先コード
   *
   * @private
   * @type {string}
   * @memberof GetSupplierNameService
   */
  private paramSupplierCode: string = <string>'';

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSupplierNameService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSupplierNameService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SupplierCode: this.paramSupplierCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSupplierNameService
   */
  execute(model: any, supplierCode: string, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.paramSupplierCode = supplierCode;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetSupplierName', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSupplierNameService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
